module.exports = __webpack_public_path__ + "static/media/face-close-eyes.ca7298c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/face-close-eyes.png
// module id = 659
// module chunks = 0